import { render, staticRenderFns } from "./TimetableView-Week.vue?vue&type=template&id=07c674b5"
import script from "./TimetableView-Week.vue?vue&type=script&lang=js"
export * from "./TimetableView-Week.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports